// Shared VTT constants

export const DND_CONDITIONS = [
  { name: "Blinded", color: "#6b7280" },
  { name: "Charmed", color: "#ec4899" },
  { name: "Concentrating", color: "#3b82f6" },
  { name: "Deafened", color: "#9ca3af" },
  { name: "Flying", color: "#06b6d4" },
  { name: "Frightened", color: "#f59e0b" },
  { name: "Grappled", color: "#a855f7" },
  { name: "Incapacitated", color: "#78716c" },
  { name: "Invisible", color: "#94a3b8" },
  { name: "Paralyzed", color: "#eab308" },
  { name: "Petrified", color: "#78716c" },
  { name: "Poisoned", color: "#22c55e" },
  { name: "Prone", color: "#b45309" },
  { name: "Restrained", color: "#dc2626" },
  { name: "Stunned", color: "#fbbf24" },
  { name: "Unconscious", color: "#1f2937" },
];

export const getConditionColor = (name) =>
  DND_CONDITIONS.find((c) => c.name === name)?.color || "#a855f7";
